import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';

export default function ParcelAssessments() {
  return (
    <div className="agents-section" dir="rtl">
      <header className="agents-section-head">
        <div><h2>قطعات ساختمانی</h2><p>ارزیابی کیفیت و شرایط کالبدی ساختمان‌ها</p></div>
      </header>
      <div className="agents-empty-state">
        <span><BusinessRoundedIcon /></span>
        <h3>ارزیابی قطعات ساختمانی</h3>
        <p>فرم ارزیابی نما، پاکیزگی، کیفیت ساخت و شرایط سازه‌ای در این بخش ارائه خواهد شد.</p>
        <small>به‌زودی در دسترس</small>
      </div>
    </div>
  );
}
